import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'legend-grafic',
  templateUrl: './legend-grafic.component.html',
  styleUrls: ['./legend-grafic.component.scss']
})
export class LegendGraficComponent implements OnInit{
  @Input() labels: Array<Object>;

  @Input() width = 'auto' // Largura
  @Input() heigth = 'auto' // Altura
  @Input() direction = 'row' // row ou column
  @Input() position = 'right'; // posição right, left, center
  @Input() enableHidden = true;
  @Input() dataSetName = '';
  @Input() titleGroup = null;
  @Input() columns: number[] = [];
  @Input() errorBars = false;
  @Input() printLegend = false;
  @Input() noBackground = false;

  @Output() hiddenData = new EventEmitter();

  valuesLegend = [];

  ngOnInit(): void {
    this.createObjValuesLegend();
  }

  createObjValuesLegend() {
    this.labels = this.labels.map((res: any) => {
      const hiddenData = res?.hidden ? res.hidden : false;
      return {
        ...res,
        hidden: hiddenData
      }
    })
    if (this.columns && this.columns.length > 0 && this.labels) {
      const sumColumns = this.columns.reduce((acumulator, item) => acumulator + item, 0);
      let columns = this.columns;
      if (this.columns.length === 1) {
        columns = new Array(Math.ceil(this.labels.length / this.columns[0])).fill(this.columns[0]);
      } else if (sumColumns < this.labels.length) {
        const sumVal = Math.ceil((this.labels.length - sumColumns) / this.columns[this.columns.length - 1]);
        columns = [...this.columns, ...new Array(sumVal).fill(this.columns[this.columns.length - 1])];
      }
      this.valuesLegend = this.mountObjValuesLegend(columns);
    } else {
      this.valuesLegend = [this.labels];
    }
  }

  mountObjValuesLegend(columns: number[]): any[] {
    let lastPosition = 0;
    const nowValue = [];
    columns.forEach(count => {
      const values = this.labels.slice(lastPosition, (lastPosition + count));
      if (values.length > 0) {
        nowValue.push(values);
      }
      lastPosition += count;
    });
    return nowValue;
  }

  clickLegend(e, index, label?, disableEmission?: boolean) {
    const findLabesHiddenFalse: any = this.labels.filter((labelF: any) => labelF.hidden === false && !labelF.ignoreHidden && !labelF.hideView).length;
    let element = document.getElementById(this.dataSetName + index);
    if (findLabesHiddenFalse > 1 || element?.classList.contains('disabled-icon') || e.ignoreHidden) {
      if(!disableEmission){
        this.hiddenData.emit({
          dataSet: e,
          dataSetIndex: index.split('-')[0],
          label: label,
          dataFatherSetIndex: index.split('-')[1]
        });
      }
      element = document.getElementById(this.dataSetName + index);
      const nowlabel: any = this.labels.find(res => this.compareLabels(res, e));

      if (nowlabel) {
        if (element?.classList.contains('disabled-icon')) {
          element?.classList.remove('disabled-icon');
          nowlabel.hidden = false;
        } else {
          element?.classList.add('disabled-icon')
          nowlabel.hidden = true;
        }
      }
    }
  }

  compareLabels(res, e){
    if(this.errorBars){
      return res['label'] === e['label']
    } else {
      return res === e
    }
  }

  getStyle() {
    return this.enableHidden === false ? { 'pointer-events': 'none' } : { 'pointer-events': 'all' };
  }

  verifyIcon(icon){
    if(icon === 'cross' || icon === 'cross-secondary' || icon === 'diamond' || icon === 'triangle' ||
      icon === 'circle' || icon === 'square' || icon === 'empty-square' || icon === 'line' || icon === 'trace-line'
    ) {
      return icon;
    } else {
      return 'other';
    }
  }

}
